export default __webpack_public_path__ + "static/media/tmz_v2.39dfda07.jpg";